/**
 * custom-overrides.js
 * カスタムJavaScriptオーバーライド
 * テーマのアップデートに影響されないよう、変更はここに集約する
 */

// Ticker: normalize scroll speed based on track width
document.addEventListener('DOMContentLoaded', () => {
  const PX_PER_SECOND = 80; // 現状の日本語版に合わせた速度

  const track = document.querySelector(
    '.ai-ticker-announcement__track-an3dqestrbjnwnhk3raigenblockce6634cg9dcuc'
  );

  if (track) {
    const halfWidth = track.scrollWidth / 2; // コンテンツの実幅（複製分を除く）
    const duration = halfWidth / PX_PER_SECOND;
    track.style.animationDuration = `${duration}s`;
  }
});
